module.exports = __webpack_public_path__ + "static/media/youtubeWhite.6f5e6e5a.png";